import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, HardDriveIcon, CloudIcon } from 'lucide-react';
export function DeliverySection() {
  return <section className="py-20 bg-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-21">
        <h2 className="text-3xl font-display font-bold text-brand-navy mb-4" data-id="element-22">
          ¡Recibe Tu Biblioteca Al Instante!
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-12" data-id="element-23">
          Sin esperas. Apenas se confirme tu pago, recibirás acceso inmediato
          para descargar o ver tus libros en línea.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto" data-id="element-24">
          <motion.div whileHover={{
          y: -5
        }} className="p-6 rounded-2xl bg-gray-50 border border-gray-100" data-id="element-25">
            <div className="w-16 h-16 mx-auto bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4" data-id="element-26">
              <MailIcon size={32} data-id="element-27" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-28">Vía Email</h3>
            <p className="text-sm text-gray-500" data-id="element-29">
              Entrega directa a tu bandeja de entrada inmediatamente después de
              la compra.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="p-6 rounded-2xl bg-gray-50 border border-gray-100" data-id="element-30">
            <div className="w-16 h-16 mx-auto bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4" data-id="element-31">
              <HardDriveIcon size={32} data-id="element-32" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-33">Google Drive</h3>
            <p className="text-sm text-gray-500" data-id="element-34">
              Acceso permanente en la nube. Carpetas organizadas listas para ver
              o agregar a tu Drive.
            </p>
          </motion.div>

          <motion.div whileHover={{
          y: -5
        }} className="p-6 rounded-2xl bg-gray-50 border border-gray-100" data-id="element-35">
            <div className="w-16 h-16 mx-auto bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4" data-id="element-36">
              <CloudIcon size={32} data-id="element-37" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-38">MEGA</h3>
            <p className="text-sm text-gray-500" data-id="element-39">
              Descargas rápidas y seguras de toda la colección o packs
              específicos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}